
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[org]/workcells",
      function () {
        return require("private-next-pages/[org]/workcells/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[org]/workcells"])
      });
    }
  